<ppl-events *ngIf="!loadCategories" [itemsData]="item"></ppl-events>
<ppl-event-categories *ngIf="loadCategories" [item]="item"></ppl-event-categories>
